import { useHasScope } from "../../../../../config/globalConfig";
import NotAuthorizedDialog from "../../../../authentication/component/NotAuthorizedDialog";
import { TOKENIZED_CARD_VIEW } from "../../../utils/FinanceScope";
import ToolsFilters from "./components/filters/ToolsFilters";
import ToolsTable from "./components/tables/ToolsTable";
import { Stack } from "@mui/material";

function PaymentTools() {

    const hasScope = useHasScope;

    if (!hasScope(TOKENIZED_CARD_VIEW)) return <NotAuthorizedDialog />

    return (
            <Stack direction={"column"} spacing={2} margin={"16px"}>
                <ToolsFilters />
                <ToolsTable/> 
                
            </Stack>
    );
}

export default PaymentTools;